var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeiboDesktopLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 13,
  viewBox: "0 0 12 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7.035.1C7.032.978 8 .978 8 .978V5s2.631.056 3.331.052c0 .748.669.763.669 1.746 0 .576.137 1.391-.569 2.575-.279.468-.879 2.314-.918 3.16-.038.808-5.415.376-5.86 0C3.624 11.656 3 12 3 12V13H0V6h3.2s1.08-1.28 1.454-2.616C4.968 2.262 4.999.637 5 .146V0s1.236.032 2.035.1m-.381.905S5.685 3.21 5.34 4.335c-.127.417-.468.559-.914 1.279-.447.72-.204.946-.46 1.14C3.48 7.12 3.1 7 3.1 7L3 11s3.454 1.033 4.877 1.033 1.933-.466 1.933-.466.146-.447.146-1.395 1.11-1.228 1.11-2.42c0-.406-.372-1.638-.372-1.638L7.034 6V2.877c0-.386-.38-1.872-.38-1.872"
})));
export default SvgWeiboDesktopLike;